import React from "react";
import { Box, Button, IconButton, Typography } from "@mui/material";
import { getStyles } from "./Footer.styles";

const Footer = () => {
  const styles = getStyles();

  return (
    <Box sx={styles.footerContainer}>
      <Box sx={styles.footerSection}>
        <Box sx={styles.footerDownload}>
          <Typography variant="h4" component="h4" gutterBottom>
            Descarcă aplicația Bookster
          </Typography>
          <img src="/assets/images/qr-code.svg" alt="Bookster App" />
        </Box>
        <Box sx={styles.footerSocials}>
          <Typography variant="h4" component="h4" gutterBottom>
            Urmărește-ne și pe social media
          </Typography>
          <Box sx={styles.socialsImages}>
            <IconButton
              onClick={() => {
                window.open("https://www.instagram.com/bookster.ro/", "_blank");
              }}
            >
              <img src="/assets/images/insta.png" alt="Instagram" />
            </IconButton>
            <IconButton
              onClick={() => {
                window.open("https://www.facebook.com/booksterro", "_blank");
              }}
            >
              <img src="/assets/images/fb.png" alt="Facebook" />
            </IconButton>
            <IconButton
              onClick={() => {
                window.open(
                  "https://www.linkedin.com/company/bookster",
                  "_blank"
                );
              }}
            >
              <img src="/assets/images/li.png" alt="LinkedIn" />
            </IconButton>
          </Box>
        </Box>
        <Box sx={styles.footerLinks}>
          <Button
            variant="contained"
            onClick={() => {
              window.open("/terms-and-conditions.html", "_blank");
            }}
          >
            Termeni și Condiții
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              window.open("/gdpr.html", "_blank");
            }}
          >
            GDPR
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
